import { put, call, all, takeLatest } from "redux-saga/effects";
import {
  LOGIN_PENDING,
  UPDATE_ACCOUNT_DEFAULT_PENDING,
  LOGIN_SUCCESS,
  LOGIN_UPDATE_ACCOUNT_DEFAULT,
  SG_LOGIN_UPDATE_ACCOUNT_DEFAULT,
} from "constants/actions";

import * as api from "constants/api";
import { handleError } from "./ApiError";

// LOGIN USER
function* defaultAccountUpdate(action) {
  yield put({ type: LOGIN_PENDING });
  yield put({ type: UPDATE_ACCOUNT_DEFAULT_PENDING });
  try {
    const login = yield call(api.UPDATE_ACCOUNT_DEFAULT, action.payload);
    yield put({ type: LOGIN_UPDATE_ACCOUNT_DEFAULT, payload: login.data });
    yield put({ type: LOGIN_SUCCESS, payload: login.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* updateDefaultAccount() {
  yield takeLatest(SG_LOGIN_UPDATE_ACCOUNT_DEFAULT, defaultAccountUpdate);
}

export default function* index() {
    yield all([
      updateDefaultAccount(),
    ]);
  }
  